// src/utils/auth.js
import { logout as logoutApi } from "../api/authApi";
import { resetOrbieeChatSocket } from "../services/websocket";

// // --- Auth Token ---
// export const getAuthToken = () => {
//   return document.cookie.replace(
//     /(?:(?:^|.*;\s*)authToken\s*=\s*([^;]*).*$)|^.*$/,
//     "$1"
//   );
// };

// // --- Username ---
// export const getUsername = () => {
//   const match = document.cookie.match(new RegExp("(^| )username=([^;]+)"));
//   return match ? decodeURIComponent(match[2]) : null;
// };

// // --- Full User Profile ---
// const USER_PROFILE_COOKIE = "userProfile";

// export const getUserProfile = () => {
//   const match = document.cookie.match(new RegExp(`(^| )${USER_PROFILE_COOKIE}=([^;]+)`));
//   if (!match) return null;
//   try {
//     return JSON.parse(decodeURIComponent(match[2]));
//   } catch (e) {
//     console.warn("Failed to parse user profile cookie", e);
//     return null;
//   }
// };

// // --- Auth State ---
// export const isAuthenticated = () => {
//   return !!getAuthToken() && !!getUsername();
// };

// // --- Clear All Auth Data ---
// export const signOut = () => {
//   const expire = "path=/; max-age=0; SameSite=Strict; Secure";
//   document.cookie = `authToken=; ${expire}`;
//   document.cookie = `username=; ${expire}`;
//   document.cookie = `${USER_PROFILE_COOKIE}=; ${expire}`;
// };


// --- Auth Token ---
export const getAuthToken = () => {
  return document.cookie.replace(
    /(?:(?:^|.*;\s*)authToken\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
};

// --- Username ---
export const getUsername = () => {
  const match = document.cookie.match(new RegExp("(^| )username=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

// --- User Role ---
export const getUserRole = () => {
  const match = document.cookie.match(/(?:^|;\s*)userRole\s*=\s*([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

// --- Check if Admin ---
export const isAdmin = () => {
  
  return getUserRole() === "A";
};
export const checkUser = () => {
  if(getUserRole() === "C"||getUserRole() === null){
    return false
  }
  if(getUserRole() === "A"){
    return true;
  }

};

// --- Full User Profile ---
const USER_PROFILE_COOKIE = "userProfile";

/**
 * Use backend customer_name when present; otherwise derive from email local-part.
 * e.g. emily.parker@gmail.com → "Emily parker"
 */
export function deriveCustomerNameFromEmail(email, existingName = "") {
  const trimmed = String(existingName ?? "").trim();
  if (trimmed) return trimmed;

  const emailStr = String(email ?? "").trim();
  const at = emailStr.indexOf("@");
  if (at <= 0) return "";

  const local = emailStr.slice(0, at);
  const parts = local.split(/[._-]+/).filter(Boolean);
  if (!parts.length) return "";

  return parts
    .map((part, index) => {
      const lower = part.toLowerCase();
      if (!lower) return "";
      if (index === 0) {
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      }
      return lower;
    })
    .filter(Boolean)
    .join(" ");
}

export const getUserProfile = () => {
  const match = document.cookie.match(new RegExp(`(^| )${USER_PROFILE_COOKIE}=([^;]+)`));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[2]));
  } catch (e) {
    console.warn("Failed to parse user profile cookie", e);
    return null;
  }
};

// --- Auth State ---
export const isAuthenticated = () => {
 
 
  return !!getAuthToken() && !!getUsername();
};

// --- Clear All Auth Data ---
// export const signOut = () => {
//   const expire = "path=/; max-age=0; SameSite=Strict; Secure";
//   document.cookie = `authToken=; ${expire}`;
//   document.cookie = `username=; ${expire}`;
//   document.cookie = `userRole=; ${expire}`;
//   document.cookie = `${USER_PROFILE_COOKIE}=; ${expire}`;
// };

/**
 * Forget the session on this device: the agent socket, both storages and
 * the four auth cookies. No backend call. It used to be typed out twice
 * inside `signOut`, once per try/catch branch.
 */
export function clearLocalSession() {
  resetOrbieeChatSocket();

  try {
    sessionStorage.clear();
  } catch (e) {
    console.warn("Failed to clear session storage", e);
  }
  try {
    localStorage.clear();
  } catch (e) {
    console.warn("Failed to clear local storage", e);
  }

  const isSecure = window.location.protocol === "https:";
  const clearFlags = `path=/; max-age=0; SameSite=Strict${isSecure ? "; Secure" : ""}`;
  ["authToken", "username", "userRole", "userProfile"].forEach((name) => {
    document.cookie = `${name}=; ${clearFlags}`;
  });
}

/**
 * The tail every sign-out shares: close any sign-in dialog, then a full load
 * of "/" — the reset for every context, the avatar widget and the socket,
 * far more reliable than unwinding them in place.
 */
function leaveToHome() {
  window.dispatchEvent(new CustomEvent("closeAuthModal"));
  window.location.href = "/";
}

export const signOut = async (showSuccessMessage = true, onClosePopup = null) => {
  // The socket goes first, so nothing is in flight while the session ends.
  resetOrbieeChatSocket();

  let message = "Logged out successfully";
  try {
    // 1. Tell the backend — it ends the credential + conversation session.
    const logoutResult = await logoutApi();
    message = logoutResult?.message || message;
  } catch (error) {
    // A failed call must not keep a shopper signed in; carry on locally.
    console.error("Sign out error:", error);
  }

  // 2. Forget everything on this device.
  clearLocalSession();

  // 3. Feedback and callbacks, then home.
  if (showSuccessMessage) {
    alert(message);
  }
  if (onClosePopup && typeof onClosePopup === "function") {
    onClosePopup();
  }
  leaveToHome();
};

// `signOutLocally` (2026-10-19 → 2026-10-28) signed this device out when
// the backend moved the session to another device. A takeover no longer
// signs anyone out: the socket is cut and the chat offers "Continue here"
// (services/websocket/sessionTakeover.js).
